(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-selector/assets/javascripts/draw-nav.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-selector/assets/javascripts/draw-nav.js');

'use strict';

const {
  ReactIconButton,
  ReactIcon
} = svs.ui;
const {
  If
} = svs.components.lbUtils.reactConditionals;
const DrawNav = _ref => {
  let {
    isLeftDisabled,
    isGoToSelectedDisabled,
    isRightDisabled,
    onGoToSelected,
    onPrevious,
    onNext,
    showArrowButtons
  } = _ref;
  return React.createElement("div", {
    className: "draw-nav-buttons"
  }, React.createElement(If, {
    condition: showArrowButtons
  }, React.createElement(ReactIconButton, {
    className: "qa-left-arrow-btn",
    disabled: isLeftDisabled,
    onClick: onPrevious,
    tabIndex: -1
  }, React.createElement(ReactIcon, {
    color: "fc-navy",
    icon: "menu-left",
    size: "300"
  }))), React.createElement(ReactIconButton, {
    className: "qa-center-btn",
    disabled: isGoToSelectedDisabled,
    onClick: onGoToSelected,
    tabIndex: -1
  }, React.createElement(ReactIcon, {
    color: "fc-navy",
    icon: "focus",
    size: "300"
  })), React.createElement(If, {
    condition: showArrowButtons
  }, React.createElement(ReactIconButton, {
    className: "qa-right-arrow-btn",
    disabled: isRightDisabled,
    onClick: onNext,
    tabIndex: -1
  }, React.createElement(ReactIcon, {
    color: "fc-navy",
    icon: "menu-right",
    size: "300"
  }))));
};
setGlobal('svs.components.tipsen.drawselector.DrawNav', DrawNav);

 })(window);